import { Button } from "@bb-ui/react-library";
import { ButtonProps, styled } from "@material-ui/core";

export const ToolButton = styled(Button)<ButtonProps>(() => ({
  "&:hover": {
    backgroundColor: "white",
    opacity: "1",
  },
}));
